import Helper from "./Helper";

const ArchiveProjects = {
  form: null,
  btnLoadMore: null,
  ongoingPaged: 1,
  currentBtn: null,
  currentWrapper: null,
  currentPaged: 1,
  status: null,
  currentTemplate: "card-project",

  init: () => {
    // check page
    const isArchive = document.querySelector("body.post-type-archive-project");
    if (!isArchive) return;

    ArchiveProjects.form = document.getElementById("archive-project__form");
    if (!ArchiveProjects.form) return;

    // get load more btn: ongoing
    ArchiveProjects.btnLoadMore = document.getElementById(
      "archive-project__btn-load-more"
    );

    // load more btn: ongoing
    if (ArchiveProjects.btnLoadMore) {
      ArchiveProjects.btnLoadMore.addEventListener("click", function () {
        ArchiveProjects.currentBtn = this;
        ArchiveProjects.ongoingPaged++;
        ArchiveProjects.currentPaged = ArchiveProjects.ongoingPaged;
        ArchiveProjects.status = "active";
        ArchiveProjects.currentTemplate = "card-project";
        ArchiveProjects.currentWrapper = document.getElementById("results");
        ArchiveProjects.handleSubmit();
      });
    }
  },

  handleSubmit: () => {
    console.log("load more projects...");

    // create new FormData
    const inputData = new FormData(ArchiveProjects.form);

    // create obj from FormData entries
    const inputDataObj = Object.fromEntries(inputData);
    console.log(inputDataObj);

    // wp ajax url
    let url = siteData.ajaxUrl;

    const paged = ArchiveProjects.currentPaged;
    const status = ArchiveProjects.status;
    const template = ArchiveProjects.currentTemplate;

    console.log(paged);
    console.log(status);

    // prepare data
    const data = {
      action: "netzero_get_projects_load_more",
      nonce: siteData.nonce,
      paged: paged,
      template: template,
      ...inputDataObj,
    };

    // encode data
    const query = Helper.encodeData(data);

    if (query.length) {
      url += "?" + query;
    }

    // setup fetch options
    const options = {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    };

    // fetch posts
    fetch(url, options)
      .then((res) => {
        // promise returned
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.json();
      })
      .then((res) => {
        // success
        const data = res.data;

        // get pre-rendered post items
        const items = res.data.items;

        // get posts wrapper
        const wrapper = ArchiveProjects.currentWrapper;

        if (items && items.length != -1) {
          if (wrapper) {
            items.forEach((item, index) => {
              // render each post item to the DOM
              wrapper.insertAdjacentHTML("beforeend", item);

              // // make item focusable
              // wrapper.lastChild.setAttribute("tabindex", "0");

              // if (index === 0) {
              //   // set focus to first new post item
              //   wrapper.lastChild.focus();
              // }
            });
          }
        }

        console.log("data.maxNumPages");
        console.log(data.maxNumPages);

        // check if on last page
        if (
          ArchiveProjects.currentPaged == data.maxNumPages ||
          data.maxNumPages == 0
        ) {
          // nothing more to load - disable button
          ArchiveProjects.currentBtn.setAttribute("disabled", "");
        } else {
          // were not on the last page - activate button again!
          ArchiveProjects.currentBtn.removeAttribute("disabled");
        }
      })
      .catch((err) => {
        // error
        console.log(err);

        // update btn status
        ArchiveProjects.currentBtn.removeAttribute("disabled");
      });
  },
};

export default ArchiveProjects;
